<div class="{{styles.oy_tab}}"><div class="{{styles.oy_tab_head}} clear">{{each props.tabs tab index}}<div data-index="{{index}}" class="{{$imports.classnames([ styles.oy_tab_head_item, state.current.key === tab.key && styles.active ])}}">{{tab.name}}</div>{{/each}}</div><div class="{{styles.oy_tab_content}}"><slot></slot></div></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYTab/index.art